import { useTranslation } from 'react-i18next';
import { ACTIONS_ENUM } from 'types/enums';

export const useActionSelectOptions = () => {
  const { t } = useTranslation();

  return [
    {
      label: t('flow.actions.actionsTypes.Create'),
      value: ACTIONS_ENUM.Create,
      id: 'create',
    },
    {
      label: t('flow.actions.actionsTypes.Change'),
      value: ACTIONS_ENUM.Change,
      id: 'change',
    },
    {
      label: t('flow.actions.actionsTypes.Notify'),
      value: ACTIONS_ENUM.Notify,
      id: 'notify',
    },
    {
      label: t('flow.actions.actionsTypes.DeleteNotification'),
      value: ACTIONS_ENUM.DeleteNotification,
      id: 'deleteNotification',
    },
    {
      label: t('flow.actions.actionsTypes.Archive'),
      value: ACTIONS_ENUM.Archive,
      id: 'archive',
    },
    {
      label: t('flow.actions.actionsTypes.Delete'),
      value: ACTIONS_ENUM.Delete,
      id: 'delete',
    },
    {
      label: t('flow.actions.actionsTypes.IncreaseVersion'),
      value: ACTIONS_ENUM.IncreaseVersion,
      id: 'increase',
    },
    {
      label: t('flow.actions.actionsTypes.DistinctForeach'),
      value: ACTIONS_ENUM.DistinctForeach,
      id: 'distinctForeach',
    },
    {
      label: t('flow.actions.actionsTypes.CreateForEach'),
      value: ACTIONS_ENUM.CreateForEach,
      id: 'createForEach',
    },
    {
      label: t('flow.actions.actionsTypes.Redirect'),
      value: ACTIONS_ENUM.Redirect,
      id: 'redirect',
    },
    {
      label: t('flow.actions.actionsTypes.SendDataToErp'),
      value: ACTIONS_ENUM.SendDataToErp,
      id: 'sendDataToErp',
    },
    {
      label: t('flow.actions.actionsTypes.SendDataToErpWithItems'),
      value: ACTIONS_ENUM.SendDataToErpWithItems,
      id: 'sendDataToErpWithItems',
    },
    {
      label: t('flow.actions.actionsTypes.TakeDataFromErp'),
      value: ACTIONS_ENUM.TakeDataFromErp,
      id: 'takeDataFromErp',
    },
    {
      label: t('flow.actions.actionsTypes.ExternalAction'),
      value: ACTIONS_ENUM.ExternalAction,
      id: 'externalAction',
    },
    {
      label: t('flow.actions.actionsTypes.ExternalRestApi'),
      value: ACTIONS_ENUM.ExternalRestApi,
      id: 'externalRestApi',
    },
    {
      label: t('flow.actions.actionsTypes.GoToExternalCatalogue'),
      value: ACTIONS_ENUM.GoToExternalCatalogue,
      id: 'goToExternalCatalogue',
    },
    {
      label: t('flow.actions.actionsTypes.PurchaseExternalCatalogue'),
      value: ACTIONS_ENUM.PurchaseExternalCatalogue,
      id: 'purchaseExternalCatalogue',
    },
    {
      label: t('flow.actions.actionsTypes.Dialog'),
      value: ACTIONS_ENUM.Dialog,
      id: 'dialog',
    },
    {
      label: t('flow.actions.actionsTypes.Halt'),
      value: ACTIONS_ENUM.Halt,
      id: 'halt',
    },
  ] as const;
};
